{
  "blocks": [
    {
      "id": "med-doxycycline",
      "kind": "medication",
      "tags": [
        "medications",
        "both-partners",
        "during-cycle",
        "ivf",
        "iui",
        "practical",
        "evidence-based"
      ],
      "title": "Doxycycline",
      "subtitle": "Antibiotic prophylaxis for egg retrieval and embryo transfer",
      "body": {
        "genericName": "Doxycycline",
        "drugClass": "Tetracycline antibiotic",
        "purpose": "A broad-spectrum antibiotic prescribed prophylactically around egg retrieval and embryo transfer to reduce the risk of infection. Both partners may be prescribed a short course. For the female partner, it reduces the risk of pelvic infection after the egg retrieval procedure. For the male partner, it ensures the semen sample is free of bacteria that could affect embryo culture.",
        "commonRoutes": ["oral"],
        "commonForms": ["capsule", "pill"],
        "dosageRanges": "100 mg twice daily for 5-7 days. Typically started 1-2 days before egg retrieval and continued for 3-5 days after. Male partner: 100 mg twice daily for 5-10 days before semen collection.",
        "howToTake": "Step 1: Prepare - Check your clinic's timing instructions. Avoid dairy products, antacids, and iron supplements within 2 hours of taking doxycycline as they reduce absorption. | Step 2: Take medication - Take with a full glass of water and food to reduce stomach upset. Swallow capsules whole. Do not lie down for at least 30 minutes after taking to prevent esophageal irritation. | Step 3: After taking - Avoid prolonged sun exposure while on doxycycline as it increases sun sensitivity - use sunscreen if outdoors. Complete the full course as prescribed. | ⚠ Missed dose - Take the missed dose as soon as you remember. If it is almost time for the next dose, skip the missed one. Do not take two doses at once.",
        "sideEffects": [
          "Nausea and stomach upset",
          "Photosensitivity (increased sunburn risk)",
          "Esophageal irritation (take upright with plenty of water)",
          "Diarrhea",
          "Vaginal yeast infection",
          "Headache"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from light and moisture. Do not use expired doxycycline as it can become toxic.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Doxycycline", "Vibramycin"]
          },
          {
            "country": "UK",
            "brands": ["Doxycycline", "Vibramycin"]
          },
          {
            "country": "EU",
            "brands": ["Doxycycline"]
          },
          {
            "country": "FR",
            "brands": ["Vibramycine N", "Doxylis", "Tolexine", "Doxypalu"],
            "cisByBrand": {
              "Doxylis": "60349519",
              "Tolexine": "68217804",
              "Doxypalu": "63307856"
            }
          }
        ],
        "aliases": ["Doxypalu", "Tolexine", "Vibramycine", "Vibramycin"],
        "forWhom": "both",
        "frBody": {
          "genericName": "Doxycycline",
          "drugClass": "Antibiotique tétracycline",
          "purpose": "Antibiotique à large spectre prescrit en prophylaxie autour de la ponction ovocytaire et du transfert d'embryon pour réduire le risque d'infection. Les deux partenaires peuvent recevoir une cure courte. Pour la femme, il réduit le risque d'infection pelvienne après la ponction. Pour l'homme, il garantit que le sperme est exempt de bactéries pouvant affecter la culture embryonnaire.",
          "dosageRanges": "100 mg deux fois par jour pendant 5 à 7 jours. Habituellement débuté 1 à 2 jours avant la ponction et poursuivi 3 à 5 jours après. Partenaire masculin : 100 mg deux fois par jour pendant 5 à 10 jours avant le recueil de sperme.",
          "howToTake": "Préparer - Vérifiez le calendrier indiqué par votre centre. Évitez les produits laitiers, les antiacides et les compléments en fer dans les 2 heures précédant et suivant la prise de doxycycline, car ils diminuent l'absorption. | Prendre le médicament - Prenez avec un grand verre d'eau et de la nourriture pour limiter l'inconfort gastrique. Avalez les capsules entières. Ne vous allongez pas pendant au moins 30 minutes après la prise pour éviter l'irritation œsophagienne. | Après la prise - Évitez les expositions prolongées au soleil pendant le traitement, la doxycycline augmentant la photosensibilité - utilisez une protection solaire à l'extérieur. Terminez la totalité de la cure prescrite. | ⚠ Dose oubliée - Prenez la dose oubliée dès que vous y pensez. Si l'heure de la dose suivante approche, sautez la dose oubliée. Ne prenez jamais deux doses en même temps.",
          "sideEffects": [
            "Nausées et inconfort gastrique",
            "Photosensibilité (risque accru de coup de soleil)",
            "Irritation œsophagienne (prendre en position verticale avec beaucoup d'eau)",
            "Diarrhée",
            "Mycose vaginale",
            "Maux de tête"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de la lumière et de l'humidité. Ne pas utiliser de doxycycline périmée, qui peut devenir toxique."
        }
      }
    },
    {
      "id": "med-methylprednisolone",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "post-cycle",
        "ivf",
        "fet",
        "autoimmune",
        "evidence-based"
      ],
      "title": "Methylprednisolone / Prednisone",
      "subtitle": "Corticosteroids for immune modulation around embryo transfer",
      "body": {
        "genericName": "Methylprednisolone / Prednisone",
        "drugClass": "Corticosteroid (glucocorticoid)",
        "purpose": "Some clinics use corticosteroids for selected immune or endocrine indications. Whether they belong in an FET plan depends on your clinician's review and individual history. Evidence for routine use is limited, so this article cannot determine whether they are appropriate for you.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "There is no universal FET dose or schedule. Your clinic or prescribing clinician must confirm the product, dose, route, start and stop dates, and whether any taper is needed.",
        "howToTake": "Use these corticosteroids only as prescribed and follow your clinic's order or pharmacy label. Do not start, stop, change the dose, or change the timing from this article. Ask your clinic or pharmacist what to do if a dose is late or missed, and whether you need a taper before stopping. Contact your care team about symptoms that concern you, including marked mood changes, swelling, symptoms of high blood sugar, or difficulty following the prescribed plan.",
        "sideEffects": [
          "Increased appetite and weight gain",
          "Insomnia (take in the morning)",
          "Mood changes, irritability, or anxiety",
          "Elevated blood sugar",
          "Facial flushing",
          "Stomach irritation",
          "Water retention",
          "Immune suppression (avoid sick contacts)"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from moisture and light.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Medrol", "Prednisone", "Dexamethasone"]
          },
          {
            "country": "UK",
            "brands": ["Medrone", "Prednisolone", "Dexamethasone"]
          },
          {
            "country": "EU",
            "brands": ["Medrol", "Prednisolone", "Dexamethasone"]
          },
          {
            "country": "AU",
            "brands": ["Medrol", "Predmix", "Dexamethasone"]
          },
          {
            "country": "FR",
            "brands": ["Cortancyl", "Solupred", "Médrol"],
            "cisByBrand": {
              "Cortancyl": "62390849",
              "Solupred": "63226984",
              "Médrol": "64639548"
            }
          }
        ],
        "aliases": [
          "Medrol",
          "Prednisone",
          "Prednisolone",
          "Solupred",
          "Cortancyl",
          "Méthylprednisolone"
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Méthylprednisolone / Prednisone",
          "drugClass": "Corticoïde (glucocorticoïde)",
          "purpose": "Certains centres utilisent des corticoïdes dans des indications immunitaires ou endocriniennes sélectionnées. Leur place dans un plan de TEC dépend de l'évaluation de votre clinicien et de vos antécédents. Les données sur l'usage systématique sont limitées ; cet article ne permet pas de déterminer si ce traitement vous convient.",
          "dosageRanges": "Il n'existe pas de dose ni de calendrier universels pour un TEC. Votre centre ou le prescripteur doit confirmer le produit, la dose, la voie, les dates de début et d'arrêt, ainsi que la nécessité éventuelle d'une diminution progressive.",
          "howToTake": "Utilisez ces corticoïdes uniquement sur prescription et suivez l'ordonnance de votre centre ou l'étiquette de la pharmacie. Ne commencez pas, n'arrêtez pas, ne modifiez pas la dose et ne changez pas le calendrier à partir de cet article. Demandez à votre centre ou à votre pharmacien quoi faire en cas de dose retardée ou oubliée, et si une diminution progressive est nécessaire avant l'arrêt. Contactez votre équipe en cas de symptôme préoccupant, notamment changement d'humeur marqué, œdèmes, signes d'hyperglycémie ou difficulté à suivre le plan prescrit.",
          "sideEffects": [
            "Augmentation de l'appétit et prise de poids",
            "Insomnie (à prendre le matin)",
            "Changements d'humeur, irritabilité ou anxiété",
            "Élévation de la glycémie",
            "Bouffées de chaleur faciales",
            "Irritation gastrique",
            "Rétention d'eau",
            "Immunosuppression (éviter les contacts avec des personnes malades)"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de l'humidité et de la lumière."
        }
      }
    },
    {
      "id": "med-cabergoline",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "post-cycle",
        "ivf",
        "egg-freezing",
        "evidence-based"
      ],
      "title": "Dostinex",
      "subtitle": "Cabergoline - dopamine agonist for OHSS prevention",
      "body": {
        "genericName": "Cabergoline",
        "drugClass": "Dopamine agonist",
        "purpose": "Primarily used in fertility treatment for prevention and management of ovarian hyperstimulation syndrome (OHSS). Cabergoline blocks the vascular endothelial growth factor (VEGF) pathway, reducing the vascular permeability that causes fluid to leak from blood vessels into the abdomen in OHSS. Started on the day of egg retrieval (or trigger day) and continued for about 8 days. Also used to treat hyperprolactinemia, which can cause anovulation.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "OHSS prevention: 0.5 mg daily for 8 days starting on the day of trigger or retrieval. Hyperprolactinemia: 0.25-1 mg once or twice weekly.",
        "howToTake": "Step 1: Prepare - Check your clinic's start date - for OHSS prevention, cabergoline typically begins on the day of egg retrieval or as directed. For hyperprolactinemia, note which day(s) of the week you should take it. | Step 2: Take medication - Take at bedtime with a snack to reduce dizziness and nausea. Swallow whole with water. | Step 3: After taking - Rise slowly from sitting or lying position, especially after the first dose, as cabergoline can cause dizziness and orthostatic hypotension. For OHSS prevention, take once daily for 8 consecutive days. For hyperprolactinemia, take on the same day(s) each week. | ⚠ Missed dose - For OHSS prevention, take the missed dose as soon as you remember the same day. For hyperprolactinemia, if you miss a scheduled dose, take it as soon as possible and then return to your regular weekly schedule. Contact your clinic if unsure.",
        "sideEffects": [
          "Dizziness and lightheadedness",
          "Nausea",
          "Headache",
          "Fatigue",
          "Constipation",
          "Low blood pressure (orthostatic hypotension)",
          "Nasal congestion"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from light.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Dostinex"]
          },
          {
            "country": "UK",
            "brands": ["Dostinex", "Cabergoline"]
          },
          {
            "country": "EU",
            "brands": ["Dostinex"]
          },
          {
            "country": "AU",
            "brands": ["Dostinex", "Cabaser"]
          },
          {
            "country": "FR",
            "brands": ["Dostinex", "Cabergoline Sandoz", "Cabergoline Mylan"],
            "cisByBrand": {
              "Dostinex": "69671845"
            }
          }
        ],
        "availability": [
          {
            "name": "Dostinex",
            "manufacturer": "Pfizer",
            "countries": [
              "GB",
              "AU",
              "NL",
              "EU",
              "US",
              "MY",
              "SG",
              "HK",
              "CA",
              "BR",
              "MX"
            ]
          },
          {
            "name": "Cabaser",
            "manufacturer": "Pfizer",
            "countries": ["GB", "AU", "JP"]
          },
          {
            "name": "Cabertrix",
            "manufacturer": "Adium",
            "countries": ["BR"]
          },
          {
            "name": "Cabergolina Adium",
            "manufacturer": "Adium",
            "countries": ["BR", "AR"]
          }
        ],
        "aliases": ["Cabaser"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Cabergoline",
          "drugClass": "Agoniste dopaminergique",
          "purpose": "Utilisée principalement en AMP pour la prévention et la prise en charge du syndrome d'hyperstimulation ovarienne (SHO). La cabergoline bloque la voie du VEGF, ce qui réduit la perméabilité vasculaire à l'origine du passage de liquide depuis les vaisseaux vers l'abdomen dans le SHO. Débutée le jour de la ponction (ou le jour du déclencheur) et poursuivie environ 8 jours. Également utilisée pour traiter l'hyperprolactinémie, qui peut entraîner une anovulation.",
          "dosageRanges": "Prévention du SHO : 0,5 mg par jour pendant 8 jours, débutée le jour du déclencheur ou de la ponction. Hyperprolactinémie : 0,25 à 1 mg une à deux fois par semaine.",
          "howToTake": "Préparer - Vérifiez la date de début avec votre centre - pour la prévention du SHO, la cabergoline débute généralement le jour de la ponction ou selon les indications. Pour l'hyperprolactinémie, notez le ou les jours de la semaine où la prendre. | Prendre le médicament - Prenez au coucher avec une collation pour réduire vertiges et nausées. Avalez entier avec de l'eau. | Après la prise - Levez-vous lentement après être restée assise ou allongée, surtout après la première dose, la cabergoline pouvant provoquer des vertiges et une hypotension orthostatique. Pour la prévention du SHO, prenez une fois par jour pendant 8 jours consécutifs. Pour l'hyperprolactinémie, prenez le ou les mêmes jours chaque semaine. | ⚠ Dose oubliée - Pour la prévention du SHO, prenez la dose oubliée dès que vous y pensez le jour même. Pour l'hyperprolactinémie, prenez la dose dès que possible puis reprenez votre rythme hebdomadaire. En cas de doute, contactez votre centre.",
          "sideEffects": [
            "Vertiges et étourdissements",
            "Nausées",
            "Maux de tête",
            "Fatigue",
            "Constipation",
            "Hypotension (orthostatique)",
            "Congestion nasale"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de la lumière."
        }
      }
    },
    {
      "id": "med-metformin",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "pre-cycle",
        "during-cycle",
        "pcos",
        "metabolic",
        "evidence-based"
      ],
      "title": "Metformin",
      "subtitle": "Insulin sensitizer for PMOS (ex PCOS) and metabolic support",
      "body": {
        "genericName": "Metformin hydrochloride",
        "drugClass": "Biguanide (insulin sensitizer)",
        "purpose": "An insulin-sensitizing medication commonly prescribed for PMOS (ex PCOS) patients with insulin resistance. By improving insulin sensitivity, metformin can help restore ovulatory cycles, lower androgen levels, and improve response to ovulation induction medications. It may also reduce the risk of OHSS in PMOS (ex PCOS) patients undergoing IVF. Some evidence suggests it can improve egg quality in insulin-resistant patients by reducing the toxic effects of high insulin on developing follicles.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "500-2000 mg daily in divided doses. Typical: start 500 mg once daily, increase by 500 mg weekly to target dose of 1500-2000 mg daily. Extended-release (XR) formulation can be taken once daily.",
        "howToTake": "Step 1: Prepare - Start at a low dose (500 mg) and increase gradually over 2-4 weeks as directed to minimize GI side effects. The extended-release (XR/ER) formulation causes significantly less GI discomfort. | Step 2: Take medication - Take with meals to reduce gastrointestinal side effects. Swallow extended-release tablets whole - do not crush or chew. The standard formulation is taken 2-3 times daily with meals; XR can be taken once daily with dinner. | Step 3: After taking - GI side effects typically improve after 2-4 weeks of consistent use. Continue as directed by your clinic; some protocols stop at egg retrieval, others continue into early pregnancy. | ⚠ Missed dose - Take the missed dose with your next meal. If it is almost time for the next scheduled dose, skip the missed one. Do not take two doses at once. Contact your clinic if you are unsure whether to continue during stimulation.",
        "sideEffects": [
          "Nausea and stomach upset (usually improves after 2-4 weeks)",
          "Diarrhea (very common initially - reduce with slow dose titration)",
          "Bloating and gas",
          "Metallic taste",
          "Decreased appetite",
          "Vitamin B12 deficiency with long-term use (monitor annually)",
          "Lactic acidosis (extremely rare)"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from moisture and light.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Glucophage", "Glucophage XR", "Metformin"]
          },
          {
            "country": "UK",
            "brands": ["Glucophage", "Metformin"]
          },
          {
            "country": "EU",
            "brands": ["Glucophage", "Metformin", "Stagid"]
          },
          {
            "country": "AU",
            "brands": ["Glucophage", "Diaformin", "Diabex"]
          },
          {
            "country": "FR",
            "brands": ["Glucophage", "Stagid"],
            "cisByBrand": {
              "Glucophage": "68583940",
              "Stagid": "61232102"
            }
          }
        ],
        "aliases": ["Metformine", "Metformine chlorhydrate"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Chlorhydrate de metformine",
          "drugClass": "Biguanide (sensibilisateur à l'insuline)",
          "purpose": "Médicament sensibilisant à l'insuline couramment prescrit chez les patientes PMOS (ex SOPK) avec insulinorésistance. En améliorant la sensibilité à l'insuline, la metformine peut aider à restaurer des cycles ovulatoires, à diminuer les taux d'androgènes et à améliorer la réponse aux inducteurs de l'ovulation. Elle peut également réduire le risque de SHO chez les patientes PMOS (ex SOPK) en FIV. Des données suggèrent qu'elle peut améliorer la qualité ovocytaire en cas d'insulinorésistance, en réduisant les effets toxiques d'une insulinémie élevée sur les follicules en développement.",
          "dosageRanges": "500 à 2 000 mg par jour en doses fractionnées. Schéma type : début à 500 mg une fois par jour, augmentation de 500 mg par semaine jusqu'à atteindre 1 500-2 000 mg par jour. La forme à libération prolongée (LP) peut se prendre en une fois par jour.",
          "howToTake": "Préparer - Démarrez à faible dose (500 mg) et augmentez progressivement sur 2 à 4 semaines selon les indications, pour limiter les effets digestifs. La forme LP entraîne nettement moins d'inconfort digestif. | Prendre le médicament - Prenez avec les repas pour réduire les effets digestifs. Avalez les comprimés LP entiers - ne pas écraser ni mâcher. La forme classique se prend 2 à 3 fois par jour avec les repas ; la LP peut se prendre une fois par jour avec le dîner. | Après la prise - Les effets digestifs s'améliorent généralement après 2 à 4 semaines d'utilisation régulière. Poursuivez selon les indications de votre centre ; certains protocoles arrêtent à la ponction, d'autres poursuivent en début de grossesse. | ⚠ Dose oubliée - Prenez la dose oubliée avec le repas suivant. Si l'heure de la dose suivante approche, sautez la dose oubliée. Ne prenez jamais deux doses en même temps. En cas de doute sur la poursuite pendant la stimulation, contactez votre centre.",
          "sideEffects": [
            "Nausées et inconfort gastrique (s'améliorent généralement après 2 à 4 semaines)",
            "Diarrhée (très fréquente initialement - réduite par une augmentation progressive)",
            "Ballonnements et gaz",
            "Goût métallique",
            "Diminution de l'appétit",
            "Carence en vitamine B12 en cas d'utilisation prolongée (à surveiller chaque année)",
            "Acidose lactique (extrêmement rare)"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de l'humidité et de la lumière."
        }
      }
    },
    {
      "id": "med-diazepam",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "fet",
        "emotional",
        "practical"
      ],
      "title": "Valium",
      "subtitle": "Diazepam - anxiolytic prescribed before embryo transfer",
      "body": {
        "genericName": "Diazepam",
        "drugClass": "Benzodiazepine (anxiolytic / muscle relaxant)",
        "purpose": "A short-acting benzodiazepine sometimes prescribed as a single dose before embryo transfer to reduce anxiety and uterine cramping. It is used for the procedure only, not as an ongoing fertility medication.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "5-10 mg as a single dose, taken 30-60 minutes before embryo transfer",
        "howToTake": "Step 1: Prepare - Arrange for someone to drive you to and from your embryo transfer appointment - you must not drive after taking this medication. Do not drink alcohol on the day of transfer. | Step 2: Take medication - Take one tablet by mouth 30-60 minutes before your scheduled embryo transfer, as directed by your clinic. This is a one-time, single dose. Swallow whole with water. | Step 3: After taking - The medication causes drowsiness and muscle relaxation for several hours. You may feel sleepy for the rest of the day - plan to rest at home afterward. Do not take any additional doses. | ⚠ Missed dose - This is a single pre-procedure dose only. If you were unable to take it at the right time, inform your clinic before the transfer - do not take it late without their guidance.",
        "sideEffects": [
          "Drowsiness and sedation",
          "Dizziness",
          "Muscle relaxation",
          "Mild confusion",
          "Impaired coordination (do not drive)",
          "Dry mouth"
        ],
        "storage": "Store at room temperature (15-25°C / 59-77°F). Keep in a secure location. This is a controlled substance.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Valium", "Diazepam"]
          },
          {
            "country": "UK",
            "brands": ["Valium", "Diazepam"]
          },
          {
            "country": "EU",
            "brands": ["Valium", "Diazepam"]
          },
          {
            "country": "AU",
            "brands": ["Valium", "Antenex"]
          },
          {
            "country": "FR",
            "brands": ["Valium", "Diazépam Mylan", "Diazépam Teva"],
            "cisByBrand": {
              "Valium": "60290800",
              "Diazépam Teva": "68176802"
            }
          }
        ],
        "aliases": ["Diazépam", "Valium Roche"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Diazépam",
          "drugClass": "Benzodiazépine (anxiolytique / myorelaxant)",
          "purpose": "Benzodiazépine de courte durée d'action parfois prescrite en dose unique avant le transfert d'embryon pour réduire l'anxiété et les contractions utérines. Elle est utilisée pour le geste uniquement, pas comme traitement de fertilité au long cours.",
          "dosageRanges": "5 à 10 mg en dose unique, prise 30 à 60 minutes avant le transfert d'embryon.",
          "howToTake": "Préparer - Organisez-vous pour qu'une personne vous conduise au rendez-vous de transfert et vous ramène - vous ne devez pas conduire après la prise. Ne consommez pas d'alcool le jour du transfert. | Prendre le médicament - Prenez un comprimé par voie orale 30 à 60 minutes avant l'horaire prévu du transfert, selon les indications de votre centre. C'est une prise unique. Avalez entier avec de l'eau. | Après la prise - Le médicament provoque somnolence et relâchement musculaire pendant plusieurs heures. Vous pouvez vous sentir somnolente le reste de la journée - prévoyez de vous reposer chez vous ensuite. Ne prenez aucune dose supplémentaire. | ⚠ Dose oubliée - Il s'agit d'une dose unique préopératoire. Si vous n'avez pas pu la prendre à l'heure, prévenez votre centre avant le transfert - ne la prenez pas en retard sans avis médical.",
          "sideEffects": [
            "Somnolence et sédation",
            "Vertiges",
            "Relâchement musculaire",
            "Confusion légère",
            "Coordination altérée (ne pas conduire)",
            "Sécheresse buccale"
          ],
          "storage": "Conservez à température ambiante (15-25 °C). Gardez dans un endroit sécurisé. Médicament à prescription contrôlée."
        }
      }
    },
    {
      "id": "med-sildenafil",
      "kind": "medication",
      "tags": ["medications", "her", "during-cycle", "fet", "ivf"],
      "title": "Sildenafil",
      "subtitle": "Vaginal sildenafil - used off-label to improve a thin uterine lining",
      "body": {
        "genericName": "Sildenafil citrate",
        "drugClass": "Phosphodiesterase type 5 (PDE5) inhibitor",
        "purpose": "Sildenafil relaxes blood vessel walls through nitric-oxide signaling. In fertility care it may be used vaginally, not as the familiar oral tablet, for selected patients with a thin endometrium before embryo transfer or insemination. This is an off-label, clinic-directed use, usually supplied as a specially compounded vaginal preparation. Evidence is mixed, so your clinic decides whether it fits your situation.",
        "commonRoutes": ["vaginal"],
        "commonForms": ["suppository", "capsule"],
        "dosageRanges": "There is no universal FET dose or schedule for compounded vaginal sildenafil. Your clinic must confirm the product, strength, route, timing, and duration.",
        "howToTake": "Use compounded vaginal sildenafil only as prescribed and follow the pharmacy label or clinic order. Do not start, stop, change the dose, or change the route from this article. Ask the pharmacy or clinic for administration instructions and what to do about a late or missed dose. This is not the same as oral sildenafil; never substitute one for the other. Tell your clinic about nitrate or other heart medicines and report severe headache, chest pain, vision changes, or fainting.",
        "sideEffects": [
          "Headache",
          "Facial flushing or warmth",
          "Nasal congestion (stuffy nose)",
          "Dizziness or lightheadedness",
          "Mild vaginal irritation or discharge",
          "Visual changes such as blurred or blue-tinged vision (less common)"
        ],
        "storage": "Store as directed by the compounding pharmacy, generally below 25°C (77°F) and away from heat, light, and moisture; some compounded vaginal preparations need refrigeration at 2-8°C (36-46°F), so follow the label and keep out of reach of children.",
        "forWhom": "her",
        "aliases": ["Sildenafil citrate", "Sildenafil", "vaginal Viagra"],
        "availability": [
          {
            "name": "Compounded vaginal sildenafil",
            "manufacturer": "Compounding pharmacy",
            "countries": ["GB", "US"]
          },
          {
            "name": "Viagra (oral, repurposed off-label)",
            "manufacturer": "Pfizer",
            "countries": ["GB", "US", "EU"]
          }
        ],
        "frBody": {
          "genericName": "Citrate de sildénafil",
          "drugClass": "Inhibiteur de la phosphodiestérase de type 5 (PDE5)",
          "purpose": "Le sildénafil vaginal peut être discuté dans certains cas sélectionnés de fertilité, notamment autour d'un transfert. C'est un usage hors AMM et propre à chaque centre, généralement avec une préparation magistrale. Les données sont contrastées ; votre clinique doit déterminer s'il est pertinent pour vous.",
          "dosageRanges": "Il n'existe pas de dose ni de calendrier universels pour le sildénafil vaginal magistral dans un TEC. Votre centre doit confirmer le produit, la concentration, la voie, le calendrier et la durée.",
          "howToTake": "Utilisez le sildénafil vaginal magistral uniquement sur prescription et suivez l'étiquette de la pharmacie ou l'ordonnance du centre. Ne commencez pas, n'arrêtez pas, ne modifiez pas la dose et ne changez pas la voie à partir de cet article. Demandez à la pharmacie ou au centre les instructions d'administration et quoi faire en cas de dose retardée ou oubliée. Ce n'est pas la même chose que le sildénafil oral ; ne remplacez jamais l'un par l'autre. Signalez à votre centre les dérivés nitrés ou autres médicaments cardiaques, ainsi que les maux de tête sévères, douleurs thoraciques, troubles de la vision ou malaises.",
          "sideEffects": [
            "Maux de tête",
            "Rougeur ou sensation de chaleur au visage",
            "Congestion nasale (nez bouché)",
            "Vertiges ou étourdissements",
            "Légère irritation vaginale ou pertes",
            "Troubles visuels comme une vision floue ou teintée de bleu (moins fréquents)"
          ],
          "storage": "Conserver selon les indications de la pharmacie, généralement en dessous de 25°C (77°F) et à l'abri de la chaleur, de la lumière et de l'humidité ; certaines préparations vaginales doivent être réfrigérées (2-8°C), suivez l'étiquette et gardez hors de portée des enfants."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
